module.exports = __webpack_public_path__ + "img/diploma.2dc18620.svg";